export default __webpack_public_path__ + "static/media/I.15759cd1.svg";